export const SUPER_ADMIN = 'SUPER_ADMIN'
export const ADMIN = 'ADMIN'
export const DEFAULT_TIMEZONE = "Europe/Moscow";
export const TYPES = ['COUPON', 'POSTCARD', 'POINTS', 'PRODUCT'];
export const EMPTY_SEGMENT = {active: false, id: "1", name: "Empty segments games", segments: []};
